<style scoped>
#upgrade {
	padding: 10px;
	min-height: 100%;
}
</style> 

<template>
	<div id="upgrade">
		<div>Welcome to this new version of JobBag. You will need to upgrade the database before continuing.</div>
		<div id="error">
			<v-alert type="error" v-if="errormsg != ''">{{
				errormsg
			}}</v-alert>
		</div>
		<div v-if="upgrading">
			<v-progress-circular
				color="black"
				indeterminate
			/>
		</div>
		<div v-if="!upgrading">
			<!-- <v-btn @click="do_upgrade()">Upgrade</v-btn> -->
			<v-btn @click="do_back()">BACK</v-btn>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			errormsg: "",
			upgrading: false,
		}
	},
	methods: {
		do_upgrade() {
			this.upgrading = true;
			let self = this;

			axios
				.get("/api/upgrade", {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// console.log(json.data);

						// recheck our token
						self.$store.dispatch('check_token');

						// navigate away
						self.$router.push(self.$store.state.redirect_after_logon);
						self.$store.commit("clear_redirect_after_logon");

					} else {
						self.errormsg = json.reason;
					}

				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.upgrading = false;
				});
		},
		do_back() {
			this.$router.push('/logon');
		}
	}
}
</script>